const sanitizeFilename = (filename) => {
  try {
    let decoded = filename;
    try {
      decoded = decodeURIComponent(filename);
    } catch {
      // malformed percent-encoding — keep as-is, sanitizer will clean it
    }

    const dotIndex = decoded.lastIndexOf('.');
    const ext = dotIndex !== -1 ? decoded.slice(dotIndex).toLowerCase() : '';
    const base = dotIndex !== -1 ? decoded.slice(0, dotIndex) : decoded;

    const sanitized = base
      .replace(/[/\\]/g, '_')
      .replace(/[^a-zA-Z0-9_\-]/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '');

    return (sanitized || Date.now().toString()) + ext;
  } catch {
    return filename;
  }
};

export default sanitizeFilename;
